import React, { useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import { motion } from 'framer-motion';
import './Dashboard.css';

// Direct imports (no lazy loading)
import MonthGraph from '../../components/Dashboard/Graph.jsx';
import FilterCalendar from '../../components/Dashboard/FilterCalendar.jsx';
import AmountOverview from '../../components/Dashboard/AmountOverview.jsx';
import RecentInvoices from '../../components/Dashboard/RecentInvoice.jsx';

// Import shared ErrorBoundary component
import { ErrorBoundary } from '../../components/shared/ErrorBoundary';

const fadeIn = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0 },
};

export default function Dashboard() {
  const sum = useSelector((state) => state.invoice.dashboardCurrencySum);
  const componentRef = useRef(null);

  useEffect(() => {
    if (componentRef.current) {
      componentRef.current.scrollTop = 0;
    }
  }, []);

  return (
    <motion.div
      ref={componentRef}
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
      className="dashboard-container"
    >
      <ErrorBoundary>
        <div className='filter-sec'>
          <FilterCalendar sum={sum} />
        </div>

        <div className='graph-overview'>
          <div className='overview-left'>
            <AmountOverview sum={sum} />
          </div>

          <MonthGraph sum={sum} />
        </div>

        <div className='recent-invoices'>
          <div className='recent-invoice-inner'>
            <RecentInvoices sum={sum} />
          </div>
        </div>
      </ErrorBoundary>
    </motion.div>
  );
}
